import { memo } from "react";
import { useUnistyles } from "react-native-unistyles";
import { View, Text, Card, Button } from "@src/components";
import { Icon } from "@src/components/Icon";

interface MonitoringUpsellBannerProps {
  onUpgrade?: () => void;
}

export const MonitoringUpsellBanner = memo(({ onUpgrade }: MonitoringUpsellBannerProps) => {
  const { theme } = useUnistyles();

  return (
    <Card
      style={{
        borderWidth: 1,
        borderColor: theme.colors.status.success,
        paddingVertical: theme.spacing.lg,
        paddingHorizontal: theme.spacing["2xl"],
      }}
    >
      <View flexDirection="row" alignItems="center" gap="sm" mb="xl">
        <Text textStyle="sm/regular">Monitoring</Text>
        <View
          flexDirection="row"
          alignItems="center"
          gap="xs"
          style={{
            backgroundColor: theme.colors.status.success,
            borderRadius: theme.spacing["3xl"],
            paddingHorizontal: theme.spacing.md,
            paddingVertical: theme.spacing.xxs,
          }}
        >
          <Icon name="crown" size={16} color={theme.colors.white.default} />
          <Text textStyle="xxs/regular" style={{ color: theme.colors.white.default }}>
            Upgrade
          </Text>
        </View>
      </View>
      <Text textStyle="xs/regular" color="textMuted" mb="3xl">
        Protect assets in real time and deploy response with Vision Intelligence 24-hour ASIAL-accredited monitoring
        service. Our highly trained in-house team know Vision Intelligence products inside and out, and are equipped to
        respond to events quickly and efficiently.
      </Text>
      <Button label="Upgrade" variant="primary" variantColor="blue" size="sm" onPress={onUpgrade ?? (() => {})} />
    </Card>
  );
});
